import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';

import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-impersonation-banner',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    template: `
        @if (auth.isImpersonating()) {
            <div class="impersonation-banner">
                <wa-icon name="eye" />
                <span
                    >Viewing as <strong>{{ auth.state().user?.email }}</strong> (read-only)</span
                >
                <wa-button size="s" variant="default" (click)="exit()">Exit</wa-button>
            </div>
        }
    `,
    styles: `
        .impersonation-banner {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.75rem;
            padding: 0.5rem 1rem;
            background: #7c3aed;
            color: #fff;
            font:
                600 13px 'Inter',
                sans-serif;
            z-index: 9999;
        }

        .impersonation-banner wa-icon {
            font-size: 16px;
        }

        .impersonation-banner wa-button::part(base) {
            color: #fff;
            border-color: rgba(255, 255, 255, 0.5);
        }

        .impersonation-banner wa-button::part(base):hover {
            background: rgba(255, 255, 255, 0.15);
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImpersonationBanner {
    readonly auth = inject(AuthService);

    exit(): void {
        void this.auth.exitImpersonation();
    }
}
